/** Deploy stamp for the web menu, matching the web footer. */
export const deployedOnLabel = (buildDate) => {
    const date = new Date(buildDate);
    if (Number.isNaN(date.getTime())) {
        return '';
    }
    return `Deployed on ${new Intl.DateTimeFormat('en-US', {
        dateStyle: 'medium',
        timeStyle: 'short',
    }).format(date)}`;
};
